import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnChanges
} from '@angular/core';

@Directive({
  selector: '[idpFocusOnElement]'
})
export class FocusOnElementDirective implements AfterViewInit, OnChanges {
  @Input() changeFocus = false;
  @Input() focus = false;
  @Input() selector = '';
  @Input() selectorType = 'class';

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.setFocus();
  }

  ngOnChanges() {
    this.setFocus();
  }

  /**
   * set focus on element only when neeeded
   */
  setFocus() {
    if (this.focus) {
      this.setFocusToElement(this.selector);
    }
  }

  /**
   * query select the element & set focus on it
   * SetTimeout used to avoid ExpressionChanged error
   */
  setFocusToElement(selector: string) {
    const elementSelector = this.getElementSelector(selector);
    setTimeout(() => {
      let element: HTMLElement;
      if (this.elementRef.nativeElement.classList.contains(selector)) {
        element = document.querySelector(elementSelector) as HTMLElement;
      } else {
        element = this.elementRef.nativeElement.querySelector(elementSelector);
      }
      element.focus();
    }, 1);
  }

  /**
   * return the css selector to query element
   */
  getElementSelector(selector: string) {
    if (this.selectorType === 'tag') {
      return selector;
    }
    return `.${selector}`;
  }
}
